// extracted by mini-css-extract-plugin
module.exports = {"title":"Qdhi1QxmH_sb_d0w3OEPb"};